import { Provider } from "react-redux";
import { ClientRouter } from "./router/Router";
import store from "store/store";
import { Toaster } from "react-hot-toast";
import { ErrorBoundary } from "pages/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <ClientRouter />
        <Toaster
          toastOptions={{
            success: {
              className:
                "text-theme900 text-xs font-semibold  bg-theme100 w-auto",
              position: "bottom-right",
              duration: 4000,
            },
            error: {
              className:
                "text-red-900 text-xs font-semibold  bg-red-100 w-auto",
              position: "bottom-right",
              duration: 4000,
            },
          }}
        />
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
